import api, { getResponseError } from '../../services/api'
import { IErrorResponse, IResponse, TResponse } from '../types/ErrorResponse'
import { TStripeAcceptResponse, TStripeConfig, TStripeOnboardingStatus } from '../types/Stripe'

let _publishableKey: string | null = null

const getConfig = async (): Promise<TStripeConfig | IErrorResponse> => {
  if (_publishableKey) return { publishableKey: _publishableKey }
  try {
    const { data } = await api.get<TStripeConfig>('/stripe/config')
    if (data) {
      _publishableKey = data.publishableKey
      return data
    }
    return { code: 1, error: 'Erro inesperado do servidor' }
  } catch (error) {
    return { code: 2, error: getResponseError(error) }
  }
}

const getOnboardingStatus = async (): Promise<TStripeOnboardingStatus | IErrorResponse> => {
  try {
    const { data } = await api.get<TStripeOnboardingStatus>(
      '/stripe/onboarding/international-sales/status'
    )
    if (data) return data
    return { code: 1, error: 'Erro inesperado do servidor' }
  } catch (error) {
    return { code: 2, error: getResponseError(error) }
  }
}

const acceptOnboarding = async (): Promise<TResponse<TStripeAcceptResponse>> => {
  try {
    const { data } = await api.post<TStripeAcceptResponse>(
      '/stripe/onboarding/international-sales/accept'
    )
    if (data) return { success: true, code: 0, error: '', data }
    return { success: false, code: 1, error: 'Erro inesperado do servidor' }
  } catch (error) {
    return { success: false, code: 2, error: getResponseError(error) }
  }
}

const StripeController = { getConfig, getOnboardingStatus, acceptOnboarding }
export default StripeController
